function nextTick() {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

async function getStickyHeaderHeight(stickyHeader) {
  // Render sticky header offscreen to get its height

  const stickyHeaderHeight = stickyHeader.offsetHeight;
  return stickyHeaderHeight;
}

(async () => {
  const header = document.querySelector(".header");


  const headerHeight = header.offsetHeight;
  header.style.setProperty("--header-height", headerHeight - 12 + "px");

  // [SC] - 3rd Nov 2026 - the sticky header is created by app.js when the DOM is ready, so wait for that.
  // This file is deferred, so it always runs before DOMContentLoaded; load is only a safety net.
  if (document.readyState !== "complete") {
    await new Promise((resolve) => {
      document.addEventListener("DOMContentLoaded", resolve, { once: true });
      window.addEventListener("load", resolve, { once: true });
    });
  }
  await nextTick();
  const stickyHeader = document.querySelector("body > .main_nav_wrapper");
  // [SC] - 3rd Nov 2026 - it only exists on desktop widths; this used to throw a console error on phones
  if (!stickyHeader) return;
  const stickyHeaderHeight = await getStickyHeaderHeight(stickyHeader);
  stickyHeader.style.setProperty("--header-height", stickyHeaderHeight + "px");

  document.body.classList.add("header-size-calculated");
})();
